// extracted by mini-css-extract-plugin
export default {"radio_selection":"RadioSelection_radio_selection__VIeGA"};